<template>
  <div class="subscription-onboarding-container">
    <v-row
      :class="{
        'heading-l-large mb-4 ml-1': $breakpoint.mobileAndDown,
        'heading-m-large mb-2 ml-1': $breakpoint.tabletAndUp,
      }"
    >
      <h1
        v-if="$breakpoint.mobileAndUp"
        class="primary--text heading"
        :class="{
          'heading-l-large': $breakpoint.mobileAndDown,
          'heading-m-large': $breakpoint.tabletAndUp,
        }"
      >
        Select a plan
      </h1>
    </v-row>
    <v-row
      v-if="loaded"
      no-gutters
      :class="{ 'flex-column-reverse': $breakpoint.mobileAndDown }"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <div :class="{ 'mb-15': $vuetify.breakpoint.height < 714 }">
          <PlanCardOnboardingComponent
            v-for="(plan, index) in plans"
            :key="index"
            :plan-info="plan"
            @select-card="selectCard"
          />
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        :class="{
          'align-self-center': $breakpoint.tabletAndUp && !planSelected,
          'pl-6': $breakpoint.tabletAndUp,
        }"
      >
        <v-row
          no-gutters
          class="header-container"
        >
          <v-col>
            <div
              v-if="($breakpoint.mobileAndUp && !planSelected) || $breakpoint.smallMobileAndDown"
              class="text-center"
            >
              <SelectPlanStepComponent :size="sizeImage" />
            </div>
            <div
              v-if="$breakpoint.tabletAndUp && planSelected"
              cols="12"
              class="shadow-card border-radius-small pa-4"
              :class="{
                'selected-card': !planSelected.isLifetime,
                'card-base-background': !planSelected.isLifetime,
                'lifetime-background': planSelected.isLifetime,
              }"
            >
              <div
                v-if="planSelected.yearCycle && !planSelected.isLifetime"
                class="chip-billing-cycle text text-l-small-regular mb-4"
              >
                {{ planSelected.yearCycle }} year subscription
              </div>
              <div
                v-if="planSelected.yearCycle && planSelected.isLifetime"
                class="chip-billing-cycle text text-l-small-regular mb-4"
              >
                {{ planSelected.yearCycle }} subscription
              </div>
              <ul class="list-style-none pl-0">
                <li
                  v-for="(benefit, index) in planSelected.benefits"
                  :key="index"
                  class="text text-l-small-regular"
                  :class="{
                    'mt-4': index > 0,
                    'grey--text text--darken-4': !planSelected.isLifetime,
                    'white--text': planSelected.isLifetime,
                  }"
                >
                  <ph-check
                    size="24"
                    weight="light"
                    color="var(--v-secondary-base)"
                    class="mr-2"
                  />
                  <p
                    class="mb-0"
                    v-html="benefit"
                  />
                </li>
                <li
                  v-for="(limitation, index) in planSelected.limitations"
                  :key="index + uniqueKeysHelper()"
                  :class="{
                    'white--text': planSelected.isLifetime,
                    'grey--text text--darken-4': !planSelected.isLifetime,
                  }"
                  class="text mt-4 text-l-small-regular"
                >
                  <ph-x
                    size="24"
                    weight="light"
                    color="var(--v-error-base)"
                    class="mr-2"
                  />
                  <p class="mb-0 text-decoration-line-through">{{ limitation }}</p>
                </li>
              </ul>
            </div>
          </v-col>
          <v-col
            v-if="$breakpoint.smallMobileAndDown"
            class="align-self-center"
          >
            <h1 class="heading heading-m-small primary--text">Select a plan</h1>
          </v-col>
        </v-row>
        <v-row
          v-if="$breakpoint.tabletAndUp"
          class="fixed-button-select-plan"
          no-gutters
        >
          <v-col>
            <v-btn
              :disabled="!planSelected"
              ripple
              depressed
              :block="$breakpoint.mobileAndDown"
              :height="$breakpoint.mobileAndDown ? '44px' : '36px'"
              color="primary"
              class="heading heading-s-small align-self-center white--text unaltered-text-cap shadow-light-button px-6"
              @click="confirmPlanSelection"
            >
              Select plan
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <ProgressBarComponent
      v-else
      v-show="!loaded"
      :title="'plans'"
    />
    <v-row
      v-if="$breakpoint.mobileAndDown"
      class="fixed-button-select-plan"
      no-gutters
    >
      <v-col>
        <v-btn
          :disabled="!planSelected"
          ripple
          depressed
          :block="$breakpoint.mobileAndDown"
          :height="$breakpoint.mobileAndDown ? '44px' : '36px'"
          color="primary"
          class="heading heading-s-small align-self-center white--text unaltered-text-cap shadow-light-button px-6"
          @click="confirmPlanSelection"
        >
          Select plan
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// TODO: deprecated component, we have to remove it

import { v4 as uuidv4 } from 'uuid';
import { PhCheck, PhX } from 'phosphor-vue';
import { mapActions } from 'vuex';
import ProgressBarComponent from '@/components/common/ProgressBarComponent';
export default {
  components: {
    PhCheck,
    PhX,
    SelectPlanStepComponent: () => import('../onboarding/images/SelectPlanStepComponent.vue'),
    PlanCardOnboardingComponent: () => import('./PlanCardOnboardingComponent.vue'),
    ProgressBarComponent,
  },
  data: () => ({
    uniqueKeysHelper: uuidv4,
    planSelected: null,
    loaded: false,
    plans: [
      {
        index: 1,
        title: 'Free Trial',
        description: 'Up to 5 CME credits',
        priceMonthly: 0,
        billedAnually: 0,
        isFree: true,
        isSelected: false,
        benefits: ['Unlimited access to articles', 'Earn 5 additional CME credits for each colleague you refer'],
        limitations: [
          'Up to 100 CME credits per billing cycle',
          'Access to all Premium Content',
          'MOC credit available for participating medical boards',
          'Entire course catalog to meet all state radiation safety requirements',
          'Earn $50 off your next subscription fee for each colleague you refer',
        ],
      },
      {
        index: 2,
        title: 'Standard',
        description: 'Up to 50 CME credits per year',
        priceMonthly: 0,
        billedAnually: 0,
        isFree: false,
        price: 0,
        priceHash: null,
        yearCycle: '1',
        isSelected: false,
        benefits: [
          'Billed yearly at ',
          'Access to all Premium Content',
          'MOC credit available for participating medical boards',
          'Entire FluoroSafety course catalog to meet all state radiation safety requirements',
          'Earn $50 off your next subscription fee for each colleague you refer',
        ],
      },
      {
        index: 3,
        title: 'Professional',
        description: 'Up to 100 CME credits per billing cycle',
        priceMonthly: 0,
        isFree: false,
        price: 0,
        priceHash: null,
        yearCycle: '3',
        isSelected: false,
        benefits: [
          'Billed every 3 years at ',
          'Access to all Premium Content',
          'MOC credit available for participating medical boards',
          'Entire FluoroSafety course catalog to meet all state radiation safety requirements',
          'Earn $50 off your next subscription fee for each colleague you refer',
        ],
        isPremium: true,
        saveMoney: 'Save 50%',
      },
    ],
  }),
  computed: {
    sizeImage() {
      if (this.$breakpoint.mobileOnly) {
        return { width: 327, height: 295 };
      }

      if (this.$breakpoint.smallMobileOnly) {
        return { width: 115, height: 115 };
      }

      return { width: 301, height: 270 };
    },
    sizeImageBenefits() {
      if (this.$breakpoint.mobileOnly) {
        return { width: 327, height: 295 };
      }

      if (this.$breakpoint.smallMobileOnly) {
        return { width: 115, height: 115 };
      }

      return { width: 301, height: 270 };
    },
  },
  async mounted() {
    this.plans = [];
    let plans = await this.getPlans();

    var title = 'Lifetime';
    plans.sort(function (x, y) {
      return x.title == title ? -1 : y.title == title ? 1 : 0;
    });

    if (plans[0].title === 'Lifetime') {
      plans[0].isLifetime = true;
      plans[0].isFree = false;
      plans[0].saveMoneyTitle = plans[0].saveMoney;
      plans[0].hasDiscount = true;
      plans[0].saveMoney = new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(plans[0].price);
      plans[0].price = plans[0].price - plans[0].discountByDefault;
      plans[0].discountByDefault = new Intl.NumberFormat('en-IN', { maximumSignificantDigits: 3 }).format(
        plans[0].discountByDefault,
      );
    }

    let index = 0;
    this.plans = plans.map((plan) => {
      plan.index = index;
      index = index + 1;
      return plan;
    });
    this.loaded = true;
  },
  methods: {
    ...mapActions('subscriptions', ['getPlans']),
    selectCard({ selectedPlanInfo, isDefaultInitialSelection = false }) {
      if (!isDefaultInitialSelection) {
        this.notifySelectPlan(selectedPlanInfo);
      }

      this.planSelected = selectedPlanInfo;

      this.plans = this.plans.map((plan) => {
        plan.isSelected = plan.id === selectedPlanInfo.id;
        return plan;
      });

      this.$emit('select-plan', this.planSelected);
    },
    confirmPlanSelection() {
      this.$emit('confirm-plan-selection');
    },
    notifySelectPlan(selectedPlan) {
      this.$eventNotifier.selectItem({
        itemListId: 'onboarding-plans',
        itemListName: 'Onboarding Plans',
        item: {
          itemId: selectedPlan.isFree ? 'free-trial' : selectedPlan.priceHash,
          itemName: selectedPlan.title,
          itemCategory: 'plan',
          currency: 'USD',
          price: selectedPlan.isFree ? 0 : selectedPlan.price,
          quantity: 1,
        },
      });
    },
  },
};
</script>

<style scoped>
.selected-card {
  border: 2px solid var(--v-secondary-border-base);
}
.chip-billing-cycle {
  color: var(--v-primary-base);
  background-color: var(--v-secondary-surface-base);
  padding: 4px 8px;
  border-radius: 4px;
  width: fit-content;
}
.lifetime-background {
  border-bottom: 3px solid #ffab18 !important;
  background-size: cover !important;
  background: url('~@/assets/subscriptions/LifetimeBenefitsBackground.svg');
}

.lifetime-foreground {
  background-color: #ffab18 !important;
}
.subscription-onboarding-container {
  position: relative;
  width: 100%;
}
.fixed-button-select-plan {
  position: absolute;
  right: 0px;
  bottom: 15px;
}

li {
  display: flex;
  align-items: flex-start;
}
li svg {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}
li p {
  flex: 1;
  width: auto;
  max-width: 100%;
}
@media (min-width: 375px) and (max-width: 600px) {
  .header-container {
    margin-top: -85px !important;
  }
}
@media (max-width: 600px) {
  .subscription-onboarding-container {
    margin-top: -6px;
  }
  .fixed-button-select-plan {
    position: relative;
    padding-top: 12px;
  }
}
</style>
